function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}><title>arrow-down</title><g transform="rotate(-90 17 16)" fill="none" fillRule="evenodd"><circle stroke="#D7DBE9" fill="#F6F7FB" cx="16" cy="16" r="16" /><g fill="#6A6D7B" fillRule="nonzero"><path d="M22.125 15.125a.875.875 0 1 1 0 1.75H9.875a.875.875 0 1 1 0-1.75h12.25z" /><path d="M11.112 16l5.507 5.506a.875.875 0 1 1-1.238 1.238l-6.125-6.125a.875.875 0 0 1 0-1.238l6.125-6.125a.875.875 0 1 1 1.238 1.238L11.112 16z" /></g></g></svg>;
});